export default __webpack_public_path__ + "static/media/pending.d78f36da.svg";